<form [formGroup]="newTrackerForm" name="new-tracker-form" (submit)="createCustomTracker()"
  (keydown.enter)="createCustomTracker()">
  <div class="modal-body">
    <div class="modal-header-wrapper">
      <h2 class="title-text">Création d’un nouveau tracker</h2>
    </div>
    <div id="modal-content-wrapper">
      <div id="name-form" class="form-field">
        <label>Type d’événement</label>
        <select [class.is-invalid]="typeInvalid" placeholder="Choisir parmi la liste" class="form-control custom-select"
          id="type-select" formControlName="type">
          <option value="" selected disabled>Choisir un type...</option>
          <option value="meal">Repas</option>
          <option value="collation">Collation</option>
          <option value="excluding_meals">Hors repas</option>
          <option value="physical_activity">Activité physique</option>
          <option value="hydration">Hydratation</option>
          <option value="symptoms">Symptômes</option>
          <option value="sleep">Sommeil</option>
          <option value="challenge_of_the_day">Défi du jour</option>
          <option value="feeling">Ressentis</option>
        </select>
        <div class="invalid-feedback">
          Veuillez entrer un type valide.
        </div>
      </div>
      <div id="name-form" class="form-field">
        <label>Nommer le trackeur</label>
        <input type="text" [class.is-invalid]="nameInvalid" class="form-control" id="name-input"
          placeholder="30 caractères maximum" formControlName="name">
        <div class="invalid-feedback">
          Veuillez entrer un nom valide.
        </div>
      </div>
      <div id="range-type-form" class="form-field">
        <label>Type d’échelle</label>
        <select [class.is-invalid]="rangeTypeInvalid" placeholder="Choisir parmi la liste"
          class="form-control custom-select" id="range-type-input" formControlName="rangeType">
          <option value="" selected disabled>Choisir un type...</option>
          <option value="note">Note</option>
          <option value="percent">Pourcentage</option>
          <option value="number">Nombre</option>
        </select>
        <div class="invalid-feedback">
          Veuillez entrer un type d'échelle valide.
        </div>
      </div>
      <div id="min-value-form" class="form-field">
        <label>Valeur minimale de l’échelle (valeur négative permise)</label>
        <input type="number" [class.is-invalid]="minValueInvalid" class="form-control" id="min-value-input"
               placeholder="Valeur numérique entière inférieure à la valeur max. (Par défaut : 0)" formControlName="minValue">
        <div class="invalid-feedback">
          Veuillez entrer une valeur numérique entière inférieure à la valeur max.
        </div>
      </div>
      <div id="max-value-form" class="form-field">
        <label>Valeur maximale de l’échelle</label>
        <input type="number" [class.is-invalid]="maxValueInvalid" class="form-control" id="max-value-input"
          placeholder="Valeur numérique entière supérieure à la valeur min." formControlName="maxValue">
        <div class="invalid-feedback">
          Veuillez entrer une valeur numérique entière supérieure à la valeur min.
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button id="cancel-button" (click)="hideModal()" type="button"
      class="btn btn-outline-primary btn-outline text-only">
      Annuler
    </button>

    <button id="validate-button" type="submit" [disabled]="!newTrackerForm.valid || isLoading"
      (click)="createCustomTracker()" type="button" class="btn btn-primary btn-gradient">
      <ng-container *ngIf="isLoading; else validateButton">
        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
        <span class="visually-hidden">Chargement...</span>
      </ng-container>
      <ng-template #validateButton>
        Valider
      </ng-template>
    </button>
  </div>
</form>
